import { serviceNames, diContainer } from '../../service-setup/diContainer';
import { emit, events, command, serviceCommands } from 'elc-service-bus';
import { SignInRepository } from '../repositories/SignInRepository';
import { AUTHENTICATION_SOURCES } from '../constants/constants';

export class SignInUseCase {
    private signInRepository: SignInRepository;

    constructor() {
        this.signInRepository = diContainer.get(serviceNames.signInRepository);
    }

    public execute = async () => {
        this.signInRepository.updateSignInProgress(true);
        this.signInRepository.apiError = null;

        emit(events.AUTH_ATTEMPT);
        try {
            const email = (this.signInRepository.email || '').trim();
            const password = (this.signInRepository.password || '').trim();

            const response = await this.signInRepository.signIn(email, password);
            this.signInRepository.updateSignInProgress(false);
            await command(serviceCommands.UPDATE_USER_DATA, {
                userId: response.userId,
                userEmail: response.userEmail,
                userRole: response.userRole,
                userCreationDate: response.userCreationDate
            });
            await command(serviceCommands.AUTH_UPDATE_DATA, {
                token: response.access_token,
                source: AUTHENTICATION_SOURCES.SIGN_IN,
                email: this.signInRepository.email.trim(),
                expiration: response.expires_in
            });
            this.signInRepository.clearStore();
        } catch (error) {
            this.signInRepository.handleCallError(error);
        }
    };
}
